import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const token = localStorage.getItem("viva_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("viva_token");
        setUser(false);
      });
  }, []);

  const finishLogin = (token, userObj) => {
    localStorage.setItem("viva_token", token);
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("viva_token");
    setUser(false);
  };

  const hasPerm = (section, mode = "view") => {
    if (!user) return false;
    if (user.is_owner) return true;
    const p = (user.permissions || {})[section] || "none";
    return mode === "view" ? p === "view" || p === "edit" : p === "edit";
  };

  const canManageAdmins = () => !!user && (user.is_owner || (user.permissions || {}).admins === "edit");

  return (
    <AuthContext.Provider value={{ user, setUser, finishLogin, logout, hasPerm, canManageAdmins }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

const NAV_ORDER = ["dashboard", "materials", "production", "production-plans", "suppliers", "purchase-orders", "admins"];
const SECTION_PATH = { dashboard: "/", materials: "/materials", production: "/production", "production-plans": "/production-plans", suppliers: "/suppliers", "purchase-orders": "/purchase-orders", admins: "/admins" };

export function firstAllowedPath(user) {
  if (!user) return "/login";
  if (user.is_owner) return "/";
  for (const s of NAV_ORDER) {
    const p = (user.permissions || {})[s];
    if (p === "view" || p === "edit") return SECTION_PATH[s];
  }
  return "/";
}
